import { render, staticRenderFns } from "./AddRecipeModal.vue?vue&type=template&id=b248af08"
import script from "./AddRecipeModal.vue?vue&type=script&lang=js"
export * from "./AddRecipeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports